import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { POINT_CONVERSION_COMPRESSED } from 'constants';
import successForm from './common-form';

ReactModal.setAppElement('body');

export default successForm({

    renderFields(){
        const { fields } = this.props;
        
        return ([
            <tr key="1">
                <td>CUIL/CUIT</td>
                <td>{fields.cuit}</td>
            </tr>,
            <tr key="2">
                <td>CBU</td>
                <td>{fields.cbu}</td>
            </tr>,
            <tr key="3">
                <td>Monto (pesos argentinos)</td>
                <td>${fields.amount}</td>
            </tr>
        ])
    }
});
